import { WagmiProvider } from 'wagmi';
import { QueryClientProvider } from '@tanstack/react-query';
import { wagmiConfig, queryClient } from '@/config/appkit';

interface Web3ProviderProps {
  children: React.ReactNode;
}

/**
 * Wraps the app with Wagmi + AppKit so Rewards → Claims can use
 * WalletConnect (QR scan, MetaMask, etc.) via useAppKit().open({ view: 'Connect' }).
 */
export function Web3Provider({ children }: Web3ProviderProps) {
  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  );
}
